import script from "./KeyboardListener.vue?vue&type=script&lang=js"
export * from "./KeyboardListener.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__